import { GetBatchUploadFormatQuery, UploadCsvMutation } from "generated/graphql";

type Columns = NonNullable<GetBatchUploadFormatQuery["batchUploadFormat"]>["columns"];
type File = NonNullable<UploadCsvMutation["uploadCsv"]>;

export const handleMatchColumns = (file: File | undefined, fieldOptions: Columns) => {
  if (!file || !file.rows || !file.rows[0]) {
    return { columns: null, error: "Invalid file structure: No rows found in the file." };
  }

  const acceptableColumns = fieldOptions.map((option) => option.label.toLowerCase());

  // Check for duplicate columns
  const columnLabels = file.rows[0];
  const labelCounts = columnLabels.reduce((acc, label) => {
    acc[label] = (acc[label] || 0) + 1;
    return acc;
  }, {});

  const duplicateColumns = Object.keys(labelCounts).filter((label) => labelCounts[label] > 1);
  if (duplicateColumns.length > 0) {
    let errorMessage = "Invalid file structure: Duplicate column name(s): ";
    errorMessage += duplicateColumns.join(", ") + (duplicateColumns.length > 1 ? " are" : " is") + " duplicated.";
    return { columns: null, error: errorMessage };
  }

  // Check for invalid columns
  const invalidColumns: string[] = [];
  const newColumnFieldMap = file.rows[0].map((columnLabel: string) => {
    const columnLabelLower = columnLabel.toLowerCase();
    if (!acceptableColumns.includes(columnLabelLower)) {
      invalidColumns.push(columnLabel);
      return null;
    }
    return columnLabel;
  });

  if (invalidColumns.length > 0) {
    let errorMessage = "Invalid file structure: ";
    errorMessage +=
      invalidColumns.join(", ") + (invalidColumns.length > 1 ? " are" : " is") + " invalid column name(s).";
    return { columns: null, error: errorMessage };
  }

  return { columns: newColumnFieldMap, error: null };
};
